import React from "react";
import { connect } from "react-redux";
import { filterSearch, clearFilters } from "../../actions/builderActions";
import componentStyles from "./FilterControls.module.scss";
import PillInput from "../PillInput/PillInput";
import { getAggregatedList } from "../../utils/sortFunctions";

import { FaFilter } from "react-icons/fa";

const FilterControls = ({
  filterSearch,
  clearFilters,
  searchFilters,
  builders,
  ...props
}) => {
  const setFilters = (e) => {
    const value = e.target.value;
    const key = e.target.name;
    filterSearch({
      ...searchFilters,
      [key]: value,
    });
  };
  const setCityFilter = (e) => {
    if (e.target.value === "null") {
      filterSearch({
        ...searchFilters,
        city: [],
      });
    } else {
      const newCityArr =
        searchFilters.city.indexOf(e.target.value) > -1
          ? searchFilters.city.splice(
              searchFilters.city.indexOf(e.target.value),
              1
            )
          : searchFilters.city.concat(e.target.value);

      filterSearch({
        ...searchFilters,
        city: newCityArr,
      });
    }
  };

  const cities = getAggregatedList(builders, "city");
  const licensedBool = getAggregatedList(builders, "licensed");
  const licenseStates = getAggregatedList(builders, "licenseState");

  return (
    <div>
      <div className="flexContainer justifyBetween">
        <h2>
          <FaFilter style={{ display: `inline`, marginRight: `1rem` }} />
          Filter Results
        </h2>

        <button
          type="button"
          className={componentStyles.clearBtn}
          onClick={clearFilters}
        >
          Clear Filters
        </button>
      </div>

      {licensedBool.length >= 2 && (
        <div style={{ marginBottom: `2rem` }}>
          <div style={{ marginBottom: `.5rem` }}>
            <span className="bold">Licensed</span>
          </div>
          <div>
            <PillInput
              name="licensed"
              label="All"
              type="radio"
              id="licensedBool_all"
              value={"null"}
              isSelected={
                searchFilters.licensed === "null" || !searchFilters.licensed
              }
              changeHandler={setFilters}
            />
            <PillInput
              name="licensed"
              label="Yes"
              type="radio"
              id="licensedBool_yes"
              value={"true"}
              isSelected={searchFilters.licensed === "true"}
              changeHandler={setFilters}
            />
            <PillInput
              name="licensed"
              label="No"
              type="radio"
              id="licensedBool_no"
              value={"false"}
              isSelected={searchFilters.licensed === "false"}
              changeHandler={setFilters}
            />
          </div>
        </div>
      )}

      {licenseStates.length >= 2 && (
        <div style={{ marginBottom: `2rem` }}>
          <div style={{ marginBottom: `.5rem` }}>
            <span className="bold">Licence State</span>
          </div>
          <div>
            <PillInput
              name="licenceState"
              label="All"
              type="radio"
              id="licenceState_all"
              value={"null"}
              isSelected={
                searchFilters.licenceState === "null" ||
                !searchFilters.licenceState
              }
              changeHandler={setFilters}
            />

            {licenseStates.map((state, i) => {
              if (state)
                return (
                  <PillInput
                    id={`licenceState_${state}_${i}`}
                    key={`licenceState_${state}_${i}`}
                    name="licenceState"
                    label={state}
                    type="radio"
                    value={state}
                    isSelected={
                      searchFilters.licenceState.toLowerCase() === state
                    }
                    changeHandler={setFilters}
                  />
                );
            })}
          </div>
        </div>
      )}

      {cities.length >= 2 && (
        <div style={{ marginBottom: `2rem` }}>
          <div style={{ marginBottom: `.5rem` }}>
            <span className="bold">Builder Location</span>
          </div>
          <div>
            <PillInput
              name="city"
              label="All"
              type="checkbox"
              id="city_all"
              value="null"
              isSelected={
                searchFilters.city === "null" ||
                searchFilters.city.length === 0 ||
                !searchFilters.city
              }
              changeHandler={setCityFilter}
            />

            {cities.map((city, i) => (
              <PillInput
                id={`city_${city}_${i}`}
                key={`city_${city}_${i}`}
                name="city"
                label={city}
                type="checkbox"
                value={city}
                isSelected={searchFilters.city.indexOf(city.toLowerCase()) > -1}
                changeHandler={setCityFilter}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  builders: state.builder.builders,
  searchFilters: state.builder.searchFilters,
});

export default connect(mapStateToProps, { filterSearch, clearFilters })(
  FilterControls
);
